module.exports = __webpack_public_path__ + "static/media/great-selected.05b53883.svg";